import React, { useState, useEffect } from "react";
import Header from "../Componentes/Header";
import Menu from "../Componentes/Menu";
import Footer from "../Componentes/Footer";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";

export default function SecundarySchool() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Cambia 768 por la resolución deseada
    };

    // Agrega un event listener para detectar cambios en el tamaño de la pantalla
    window.addEventListener("resize", handleResize);
    handleResize(); // Llama a la función para verificar el tamaño inicial

    // Limpia el event listener cuando el componente se desmonta
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div>
      <Header></Header>
      <Menu></Menu>

      {isMobile ? (
        <div>
          <div className="colPrimary">
            <h2 className="blue-textNosotros">Educación secundaria</h2>
            <p className="text-justifyNosotros">
           Innovación educativa y tecnología para el futuro<br></br>

En Britannia School, reconocemos que cada estudiante tiene habilidades, intereses y formas de aprender diferentes. Por eso, promovemos una educación inclusiva, dinámica y personalizada, que fortalece sus capacidades y le permite alcanzar su máximo potencial.<br></br>

Nuestra propuesta educativa integra la tecnología, la inteligencia artificial (IA) y las herramientas digitales como recursos para transformar los procesos de enseñanza y aprendizaje. Promovemos experiencias educativas innovadoras que estimulan la creatividad, el pensamiento crítico, la investigación y la capacidad de resolver problemas, preparando a nuestros estudiantes para comprender y desenvolverse en un entorno en constante evolución.<br></br>

A través de proyectos interdisciplinarios, actividades colaborativas, seminarios de orientación profesional y experiencias de acercamiento al mundo laboral, nuestros estudiantes desarrollan habilidades para explorar nuevas ideas, crear soluciones y utilizar la tecnología de manera responsable, ética y consciente.<br></br>

Nuestros docentes diseñan estrategias pedagógicas innovadoras, guías de aprendizaje y métodos de evaluación diversos, apoyados en recursos didácticos y tecnológicos que responden a las necesidades y fortalezas de cada estudiante.<br></br>

En Britannia School, entendemos la educación como un proceso en constante transformación, en el que la innovación, la inteligencia artificial y el aprendizaje continuo amplían las posibilidades de cada estudiante y le brindan herramientas para construir su propio futuro.<br></br>
            </p>
          </div>
          <Carousel
            showThumbs={true}
            autoPlay={true}
            infiniteLoop={true}
            dynamicHeight={true}
          >
            <div>
              <img src="https://britanniaschool.co.com/imagenes/SecundarySchool1.png" />
            </div>
            <div>
              <img src="https://britanniaschool.co.com/imagenes/SecundarySchool2.png" />
            </div>
            <div>
              <img src="https://britanniaschool.co.com/imagenes/SecundarySchool3.png" />
            </div>
            <div>
              <img src="https://britanniaschool.co.com/imagenes/SecundarySchool5.png" />
            </div>
            <div>
              <img src="https://britanniaschool.co.com/imagenes/SecundarySchool6.png" />
            </div>
            <div>
              <img src="https://britanniaschool.co.com/imagenes/SecundarySchoolNew1.png" />
            </div>
            <div>
              <img src="https://britanniaschool.co.com/imagenes/SecundarySchoolNew2.png" />
            </div>
            <div>
              <img src="https://britanniaschool.co.com/imagenes/SecundarySchoolNew3.png" />
            </div>
            <div>
              <img src="https://britanniaschool.co.com/imagenes/SecundarySchoolNew4.png" />
            </div>
            <div>
              <img src="https://britanniaschool.co.com/imagenes/SecundarySchoolNew5.png" />
            </div>
            <div>
              <img src="https://britanniaschool.co.com/imagenes/SecundarySchoolNew6.png" />
            </div>
          </Carousel>
          <center>
          <iframe width="315" height="315" src="https://www.youtube.com/embed/K4tUdImFEXU?si=ATAiRqXEaFr4IS5U" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          </center>
          <br></br>
          <a href='#' className='volver'>Volver</a>
          <br></br><br></br>
        </div>
      ) : (
        <div>
          <div class="contenedorPrimarySchool">
            <div class="columnaPrimarySchool izquierdaPrimarySchool">
              <div className="colNosotros">
                <h2 className="blue-textNosotros">Educación secundaria</h2>
                <p className="text-justifyNosotros">
                Innovación educativa y tecnología para el futuro<br></br>

En Britannia School, reconocemos que cada estudiante tiene habilidades, intereses y formas de aprender diferentes. Por eso, promovemos una educación inclusiva, dinámica y personalizada, que fortalece sus capacidades y le permite alcanzar su máximo potencial.<br></br>

Nuestra propuesta educativa integra la tecnología, la inteligencia artificial (IA) y las herramientas digitales como recursos para transformar los procesos de enseñanza y aprendizaje. Promovemos experiencias educativas innovadoras que estimulan la creatividad, el pensamiento crítico, la investigación y la capacidad de resolver problemas, preparando a nuestros estudiantes para comprender y desenvolverse en un entorno en constante evolución.<br></br>

A través de proyectos interdisciplinarios, actividades colaborativas, seminarios de orientación profesional y experiencias de acercamiento al mundo laboral, nuestros estudiantes desarrollan habilidades para explorar nuevas ideas, crear soluciones y utilizar la tecnología de manera responsable, ética y consciente.<br></br>

Nuestros docentes diseñan estrategias pedagógicas innovadoras, guías de aprendizaje y métodos de evaluación diversos, apoyados en recursos didácticos y tecnológicos que responden a las necesidades y fortalezas de cada estudiante.<br></br>

En Britannia School, entendemos la educación como un proceso en constante transformación, en el que la innovación, la inteligencia artificial y el aprendizaje continuo amplían las posibilidades de cada estudiante y le brindan herramientas para construir su propio futuro.<br></br>
                </p>
              </div>
            </div>
            <div class="columnaPrimarySchool derechaPrimarySchool">
              <center>
              <Carousel
    showThumbs={true}
    autoPlay={true}
    infiniteLoop={true}
    dynamicHeight={true}
  >
    <div>
      <img src="https://britanniaschool.co.com/imagenes/SecundarySchool1.png" />
    </div>
    <div>
      <img src="https://britanniaschool.co.com/imagenes/SecundarySchool2.png" />
    </div>
    <div>
      <img src="https://britanniaschool.co.com/imagenes/SecundarySchool3.png" />
    </div>
    <div>
      <img src="https://britanniaschool.co.com/imagenes/SecundarySchool4.png" />
    </div>
    <div>
      <img src="https://britanniaschool.co.com/imagenes/SecundarySchool5.png" />
    </div>
    <div>
      <img src="https://britanniaschool.co.com/imagenes/SecundarySchool6.png" />
    </div>
    <div>
              <img src="https://britanniaschool.co.com/imagenes/SecundarySchoolNew1.png" />
            </div>
            <div>
              <img src="https://britanniaschool.co.com/imagenes/SecundarySchoolNew2.png" />
            </div>
            <div>
              <img src="https://britanniaschool.co.com/imagenes/SecundarySchoolNew3.png" />
            </div>
            <div>
              <img src="https://britanniaschool.co.com/imagenes/SecundarySchoolNew4.png" />
            </div>
            <div>
              <img src="https://britanniaschool.co.com/imagenes/SecundarySchoolNew5.png" />
            </div>
            <div>
              <img src="https://britanniaschool.co.com/imagenes/SecundarySchoolNew6.png" />
            </div>
  </Carousel>
              </center>
            </div>
          </div>

          <center>
          <iframe width="560" height="315" src="https://www.youtube.com/embed/K4tUdImFEXU?si=ATAiRqXEaFr4IS5U" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          </center>

          <br></br>

          <br></br>
          <a href='#' className='volver'>Volver</a>
          <br></br><br></br>

          <br></br>
        </div>
      )}

      <Footer></Footer>
    </div>
  );
}
